import {AsyncMultiChoice, FormField} from 'platform/components';
import {VStack} from 'platform/foundation';

import {Controller} from 'react-hook-form';

import {useBulkUserOptions} from '@dms/api/core';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {BulkOperationForm, type BulkOperationActionCallbackParams} from 'features/eag-grid';

import {CustomerReassignBulkFormSchema} from './CustomerReassignBulkFormSchema';

export function CustomerReassignBulkForm(props: {action: BulkOperationActionCallbackParams}) {
  const {loadOptions, loadLabels} = useBulkUserOptions(handleApiError);
  return (
    <BulkOperationForm
      action={props.action}
      onError={handleApiError}
      experimentalZodSchema={CustomerReassignBulkFormSchema}
      defaultValues={{assigneeIds: [], assigneeMode: null}}
      toParams={(values) => values}
    >
      {(control) => (
        <VStack spacing={3}>
          <Controller
            control={control}
            name="assigneeIds"
            render={({field, fieldState}) => (
              <AsyncMultiChoice<string>
                name={field.name}
                value={field.value}
                onChange={(values) => field.onChange(values ?? [])}
                onBlur={field.onBlur}
                label={i18n.t('general.labels.participation.type.assignees')}
                errorMessage={fieldState.error?.message}
                loadOptions={loadOptions}
                loadLabels={loadLabels}
                isDisabled={field.disabled}
                menuInPortal
              />
            )}
          />
          <FormField
            type="choice"
            control={control}
            name="assigneeMode"
            label={i18n.t('general.labels.type')}
            options={[
              {value: 'REPLACE', label: i18n.t('general.actions.replace')},
              {value: 'ADD', label: i18n.t('general.actions.add')},
              {value: 'REMOVE', label: i18n.t('general.actions.remove')},
            ]}
            menuInPortal
            isRequired
          />
        </VStack>
      )}
    </BulkOperationForm>
  );
}
